function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJudaismStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 66.058594 50.578125 L 71.730469 60.210938 L 60.480469 60.210938 Z M 45 75.511719 L 39.421875 65.878906 L 50.578125 65.878906 Z M 18.269531 60.210938 L 23.941406 50.578125 L 29.519531 60.210938 Z M 18.269531 29.789062 L 29.519531 29.789062 L 23.941406 39.421875 Z M 45 14.488281 L 50.578125 24.121094 L 39.421875 24.121094 Z M 62.820312 45 L 53.910156 60.210938 L 36.089844 60.210938 L 27.179688 45 L 36.089844 29.789062 L 53.910156 29.789062 Z M 71.730469 29.789062 L 66.058594 39.421875 L 60.480469 29.789062 Z M 69.300781 45 L 81.539062 24.121094 L 57.148438 24.121094 L 45 3.238281 L 32.851562 24.121094 L 8.460938 24.121094 L 20.699219 45 L 8.460938 65.878906 L 32.851562 65.878906 L 45 86.761719 L 57.148438 65.878906 L 81.539062 65.878906 Z M 69.300781 45 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudaismStar);
export default __webpack_public_path__ + "static/media/judaism-star.828b4bbde3361d11c1b37c1f5d2b226e.svg";
export { ForwardRef as ReactComponent };